<template>
    <van-popup :show="show" :position="type" @click-overlay="handleClose" class="van-popup-container">
        <div class="popup-box"
            :class="[className, type]"
            :style="styleObj">
            <slot name="header">
                <div class="header"
                    :class="[headerClassName]">
                    <SvgIcon icon="popup.close.icon"
                        @click="handleClose()"
                        className="pointer">
    
                    </SvgIcon>
                </div>
            </slot>
            <div class="popup-body">
                <slot name="default"></slot>
            </div>
            <slot name="footer"></slot>
        </div>
    </van-popup>
    <!-- <div class="popup-container">
        <div class="popup-cover"
            :class="show ? 'show' : 'hide'"
            v-show="show"
            @click="handleClose()"></div>
    </div> -->

</template>

<script>
    import { mapState, mapGetters } from 'vuex'
    export default {
        name: 'Popup',
        data() {
            return {
                isFirstTime: true,
                // show: false,
            }
        },
        watch: {
            // show: {
            //     immediate: true,
            //     handler(newVal) {
            //         newVal
            //         ? (document.body.style.overflow = "hidden")
            //         : (document.body.style.overflow = "unset");
            //     }
            // }
        },
        computed: {
            ...mapGetters([
                'isMobileRealTime'
            ])
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            className: String,
            headerClassName: String,
            type: {
                type: String,
                default: 'right'
            },
            styleObj: [String, Object]
        },
        mounted() {
            setTimeout(() => {
                this.isFirstTime = false;
            }, 1000)
        },
        methods: {
            handleClose() {
                this.$emit('update:show', false)
            }
        }
    }
</script>

<style scoped>
.popup-container {
  position: relative;
}
.popup-cover {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.7);
  z-index: 2;
}
.popup-box {
  background-color: var(--color-background-default-secondary);
  /* position: fixed; */
  z-index: 10;
  height: 100%;
  overflow: auto;
}


.popup-box.right {
    right: 0;
    top: 0;
    width: 375px;
    height: 100%;
}

.popup-box.right.show {
    right: 0;
    opacity: 1;
    animation: rightShow .2s;
}
.popup-box.right.hide {
    right: -300%;
    opacity: 0;
    animation: rightHide .5s;
}
@keyframes rightShow {
    from {
        right: -100%;
    } to {
        right: 0;
        display: none;
    }
}
@keyframes rightHide {
    from {
        right: 0%;
    } to {
        right: -100%;
    }
}


.popup-box.center {
    left: 50%;
    top: 50%;
    width: 600px;
    min-height: 50px;
    /* transform: translate3d(-50%, -50%, 0); */
    border-radius: 16px;
}
.popup-box.center.show {
    transform: translate3d(-50%, -50%, 0)scale(1);
    animation: centerShow .2s;
}
.popup-box.center.hide {
    transform: translate3d(-50%, -50%, 0)scale(0);
    animation: centerHide .2s;
}
@keyframes centerShow {
    from {
        transform: translate3d(-50%, -50%, 0)scale(0);
    } to {
        transform: translate3d(-50%, -50%, 0)scale(1);
    }
}
@keyframes centerHide {
    from {
        transform: translate3d(-50%, -50%, 0)scale(1);
    } to {
        transform: translate3d(-50%, -50%, 0)scale(0);
    }
}

.popup-box.left {
    left: 0;
    top: 0;
    width: 375px;
    height: 100%;
}
.popup-box.bottom {
    left: 0;
    bottom: 0;
    width: 100%;
    min-height: 139px;
}

.popup-box.bottom.show {
    bottom: 0;
    opacity: 1;
    max-height: 90vh;
    animation: bottomShow .2s;
}
.popup-box.bottom.hide {
    bottom: -300%;
    opacity: 0;
    animation: bottomHide .2s;
}
@keyframes bottomShow {
    from {
        bottom: -100%;
    } to {
        bottom: 0;
    }
}
@keyframes bottomHide {
    from {
        bottom: 0;
    } to {
        bottom: -100%;
    }
}

.header {
    display: flex;
    align-items: center;
    justify-content: left;
    padding: 32px 24px 0;
}
.popup-box.center .header {
    justify-content: right;
    border-radius: 16px 16px 0 0;
}
.display-none {
    opacity: 0;
}
.popup-body {
    overflow-y: auto;
    max-height: calc(100vh - 64px);
}
.popup-box.center .popup-body {
    max-height: calc(100vh - 94px);
}
</style>

<style>

.van-popup--right {
    height: 100%;
}
.van-popup--center {
    overflow-x: hidden;
    overflow-y: hidden;
    border-radius: 16px;
    max-height: 90%;
}
.van-popup-container {
    background-color: transparent !important;
    /* overflow: hidden; */
}
</style>